import { render } from "./form.vue?vue&type=template&id=2bda7ec9"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
script.render = render

export default script